const isDirectModelPath = (modelFile: string) =>
  modelFile.startsWith("/") ||
  modelFile.startsWith("http://") ||
  modelFile.startsWith("https://");

export const buildModelUrl = (modelsDirectory: string, modelFile: string) =>
  isDirectModelPath(modelFile) ? modelFile : `${modelsDirectory}/${modelFile}`;
